import style from './AlertBase.module.scss';

const AlertBase = ({ children, type = '' }) => {
  return <div className={`${style.alert} ${type ? style['alert-' + type] : ''}`}>{children}</div>;
};

export default AlertBase;
